/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Api_Keys_One_Time_Modal_Copy_Aria_LabelInputs */

const es_user_profile_api_keys_one_time_modal_copy_aria_label = /** @type {(inputs: User_Profile_Api_Keys_One_Time_Modal_Copy_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar clave API`)
};

const en_user_profile_api_keys_one_time_modal_copy_aria_label = /** @type {(inputs: User_Profile_Api_Keys_One_Time_Modal_Copy_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy API key`)
};

/**
* | output |
* | --- |
* | "Copy API key" |
*
* @param {User_Profile_Api_Keys_One_Time_Modal_Copy_Aria_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_api_keys_one_time_modal_copy_aria_label = /** @type {((inputs?: User_Profile_Api_Keys_One_Time_Modal_Copy_Aria_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Api_Keys_One_Time_Modal_Copy_Aria_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_api_keys_one_time_modal_copy_aria_label(inputs)
	return en_user_profile_api_keys_one_time_modal_copy_aria_label(inputs)
});
export { user_profile_api_keys_one_time_modal_copy_aria_label as "user.profile.api_keys.one_time_modal.copy_aria_label" }